import { Component, Input } from '@angular/core';

@Component({
  selector: 'rr-spinner',
  standalone: false,

  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  @Input() inverse: boolean = false;

}
